module.exports = __webpack_public_path__ + "img/race_25.8d076fe8.png";